
export default {
  mounted() {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-unused-expressions, no-undef
    dataLayer.push({
      event: "generate_lead",
      "user.data_email": this.$route.query.email,
      "user.data_first_name": this.$route.query.nom,
      "user.data_phone": this.$route.query.telephone,
    });
  },
};
